import { IPromise } from 'angular';
import { IDjangoOrder, IDjangoOrderSummary } from '..';
import DjangoClient from '../../tn.django/django-client.service/djangoClient';

/**
 * A repository for interacting with orders on the the server.
 * @param {object} djangoClient - Service that helps to perform HTTP calls
 * @return {$q} $q - Angular $q service
 */
export class OrderRepository {
    protected baseUri = '/api/1/orders/';

    static $inject = ['djangoClient'];
    constructor(protected djangoClient: DjangoClient) {}

    public get(id: number): IPromise<IDjangoOrder> {
        const url = this.baseUri + id;
        return this.djangoClient.get<IDjangoOrder>(url);
    }

    public getAll(): IPromise<IDjangoOrderSummary[]> {
        return this.djangoClient.get<IDjangoOrderSummary[]>(this.baseUri);
    }

    // TODO: Move to projects service or repository.
    public updateProjects(id: string): IPromise<void> {
        const url = this.baseUri + id + '/updateprojects';
        return this.djangoClient.put(url);
    }
}
